import axios from "axios";

axios.interceptors.request.use(
    config => {
        config.headers['token'] = "pass";
        return config;
    }
);


/**
 * 获取列表
 * @param params 参数
 * @returns
 */
export const getPage = (page, size, uid, nickname, sort) => {
    return axios.get('/api/user/getPage?page=' + page + '&size=' + size + '&uid=' + uid + '&nickname=' + nickname + '&sort=' + sort);
};

/**
 * 获取用户的IDFA变更记录
 * @param userId
 * @returns 
 */
export const getIDFARecord = (userId) => {
    return axios.get('/api/idfaRecord/getIDFARecord?userId=' + userId);
};


/**
 * 获取用户的DID变更记录
 * @param userId
 * @returns
 */
export const getDIDRecord = (userId) => {
    return axios.get('/api/didRecord/getDIDRecord?userId=' + userId);
};

/**
 * 获取用户的地址变更记录
 * @param userId
 * @returns
 */
export const getAddressRecord = (userId) => {
    return axios.get('/api/address/getAddressChangeRecord?userId=' + userId);
};




/**
 * 获取用户的红包记录变更记录
 * @param userId
 * @returns 
 */
export const getUserDailyTotalAmount = (page,size,userId) => {
    return axios.get('/api/record/getUserDailyTotalAmount?page=' + page + '&size=' + size + '&userId=' + userId);
};


/**
 * 获修改用户余额
 * @param userId
 * @returns 
 */
export const editBalance = (userId,balance) => {
    return axios.get('/api/user/editBalance?userId=' + userId + '&balance=' + balance);
};


/**
 * 代理用户查询
 * @param params 参数
 * @returns
 */
export const getWhiteUserList = (page, size, uid, nickname) => {
    return axios.get('/api/user/getWhiteUserList?page=' + page + '&size=' + size + '&uid=' + uid + '&nickname=' + nickname);
};

/**
 * 代理用户查询
 * @param params 参数
 * @returns
 */
export const openNotice = (userId) => {
    return axios.get('/api/user/openNotice?userId=' + userId );
};



/**
 * 根据id查询
 * @param params 参数
 * @returns
 */
export const getUserById = (params) => {
    return axios.get('/api/user/getUserById?id=' + params);
};

/**
 * 新增
 * @param params
 * @returns
 */
export const add = (params) => {
    return axios.post('/api/user/admin/add', params);
};

/**
 * 更新
 * @param params
 * @returns
 */
export const edit = (params) => {
    return axios.post('/api/user/admin/update', params);
};


/**
 * 根据id删除
 * @param params
 * @returns
 */
export const changeBlock = (params) => {
    return axios.get('/api/user/changeBlock?id=' + params);
};

/**
 * 审核
 * @param params
 * @returns
 */
export const check = (id, status) => {
    return axios.get('/api/user/check?id=' + id + '&status=' + status);
};

/**
 * 取消代理
 * @param params
 * @returns
 */
export const cancelWhite = (id, status) => {
    return axios.get('/api/user/cancelWhite?id=' + id);
};


/**
 * 加白
 * @param params
 * @returns
 */
export const setWhite = (userId) => {
    return axios.get('/api/user/setWhite?userId=' + userId);
};

/**
 * 拉黑
 * @param params
 * @returns
 */
export const addBlack = (userId) => {
    return axios.get('/api/user/addBlack?userId=' + userId);
};

/**
 * 限时拉黑（输入拉黑天数，到期自动解除）
 * @param userId 用户id
 * @param days   拉黑天数（如1表示1天）
 * @returns
 */
export const addBlackByDays = (userId, days) => {
    return axios.post('/api/user/addBlackByDays?userId=' + userId + '&days=' + days);
};
/**
 * 取消拉黑
 * @param params
 * @returns
 */
export const removeBlack = (userId) => {
    return axios.get('/api/user/removeBlack?userId=' + userId);
};

/**
 * 设备拉黑
 * @param params
 * @returns
 */
export const addIDFABlack = (idfa,reason) => {
    return axios.get('/api/idfaRecord/addIDFABlack?idfa=' + idfa+'&reason='+reason);
};

/**
 * 取消设备拉黑
 * @param params
 * @returns
 */
export const removeIDFABlack = (idfa) => {
    return axios.get('/api/idfaRecord/removeIDFABlack?idfa=' + idfa);
};

/**
 * 设备拉黑(DID)
 * @param params
 * @returns
 */
export const addDIDBlack = (did,reason) => {
    return axios.get('/api/didRecord/addDIDBlack?did=' + did+'&reason='+reason);
};

/**
 * 取消设备拉黑
 * @param params
 * @returns
 */
export const removeDIDBlack = (did) => {
    return axios.get('/api/didRecord/removeDIDBlack?did=' + did);
};


/**
 * 切换邀请权限
 * @param userId 用户id
 * @returns
 */
export const changeInviteStatus = (userId) => {
    return axios.get('/api/user/changeInviteStatus?userId=' + userId);
};

/**
 * 用户统计信息
 * @param params
 * @returns
 */
export const getUserStatisticsVo = (userId) => {
    return axios.get('/api/user/getUserStatisticsVo?userId=' + userId);
};

/**
 * 用户统计信息
 * @param params
 * @returns
 */
export const total = () => {
    return axios.get('/api/user/admin/total');
};


/**
 * ip统计
 * @param params 参数
 * @returns {AxiosPromise}
 */
export const getIpVoPage = (page, size, uid, city, sortField, sortOrder) => {
    return axios.get('/api/user/getIpVoPage?page=' + page + '&size=' + size + '&uid=' + uid + '&city=' + city + '&sortField=' + sortField + '&sortOrder=' + sortOrder);
};


/**
 * 删除用户
 * @param params
 * @returns
 */
export const deleteById = (userId) => {
    return axios.get('/api/user/deleteById?id=' + userId);
};

/**
 * 上传文件
 * @param params
 * @returns
 */
export const uploadImg = (params) => {
    return axios.get('/api/user/uploadImg?file=' + params);
};

/**
 * 获取邀请用户列表
 * @param params 参数
 * @returns {AxiosPromise}
 */
export const inviterPageList = (page, size, uid, nickname, sortField, sortOrder) => {
    return axios.get('/api/inviter/pageList', {
        params: {
            page,
            size,
            uid,
            nickname,
            sortField,  // 例如 'totalInviteCount'
            sortOrder   // 例如 'desc'
        }
    });
};
